<template>
  <v-simple-table class="special-detail-table mt-3">
    <template v-slot:default>
      <thead>
      <tr>
        <th>
          Nghỉ không phép
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-on="on"
                v-bind="attrs"
                style="font-size: 20px; margin-left: 6px">
                mdi-information-outline
              </v-icon>
            </template>
            <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
          </v-tooltip>
        </th>
        <th>
          Đi muộn về sớm
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-on="on"
                v-bind="attrs"
                style="font-size: 20px; margin-left: 6px">
                mdi-information-outline
              </v-icon>
            </template>
            <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
          </v-tooltip>
        </th>
        <th>
          Không làm bài tập
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-on="on"
                v-bind="attrs"
                style="font-size: 20px; margin-left: 6px">
                mdi-information-outline
              </v-icon>
            </template>
            <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
          </v-tooltip>
        </th>
        <th>
          Kiểm tra (unit test/final test)
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-on="on"
                v-bind="attrs"
                style="font-size: 20px; margin-left: 6px">
                mdi-information-outline
              </v-icon>
            </template>
            <div>Điểm kiểm tra dưới 5/ giảm 2 điểm so với bài kiểm tra gần nhất</div>
          </v-tooltip>
        </th>
        <th>Hủy buổi</th>
        <th>Đổi giáo viên</th>
        <th>Bài kiểm tra sắp tới</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <div v-if="item.no_adtention && item.no_adtention.details" class="d-flex">
            <div>
              <div>{{item.no_adtention.details.length}} buổi</div>
              <div v-if="item.no_adtention.lienTiep">Liên tiếp: {{item.no_adtention.lienTiep}} buổi</div>
            </div>
            <v-tooltip bottom v-if="_.get(item, 'no_adtention.details', []).length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 12px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>
                <div v-for="(item, index) in item.no_adtention.details" :key="'no_adtention'+ index" class="d-flex align-center justify-end">
                  <div v-show="item.isLienTiep" class="continuous-dot mr-2"></div> {{index + 1}}. {{item.text}}
                </div>
              </div>
            </v-tooltip>
          </div>
          <div v-else>
            <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </td>
        <td>
          <div v-if="item.late && item.late.details" class="d-flex">
            <div>
              <div v-if="item.late.lessons">{{item.late.lessons }} buổi</div>
              <div v-if="item.late.lienTiep">Liên tiếp: {{item.late.lienTiep}} buổi</div>
            </div>
            <v-tooltip bottom v-if="_.get(item, 'late.details', []).length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 12px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>
                <div v-for="(item, index) in item.late.details" :key="'late'+ index" class="d-flex align-center justify-end">
                  <div v-show="item.isLienTiep" class="continuous-dot mr-2"></div> {{index + 1}}. {{item.text}}
                </div>
              </div>
            </v-tooltip>
          </div>
          <div v-else>
            <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </td>
        <td>
          <div v-if="item.no_homework && item.no_homework.details" class="d-flex">
            <div>
              <div>{{item.no_homework.details.length}} bài</div>
              <div v-if="item.no_homework.lienTiep">Liên tiếp: {{item.no_homework.lienTiep}} bài</div>
            </div>
            <v-tooltip bottom v-if="_.get(item, 'late.details', []).length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 12px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>
                <div v-for="(item, index) in item.no_homework.details" :key="'no_homework'+ index" class="d-flex align-center justify-end">
                  <div v-show="item.isLienTiep" class="continuous-dot mr-2"></div> {{index + 1}}. {{item.text}}
                </div>
              </div>
            </v-tooltip>
          </div>
          <div v-else>
            <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </td>
        <td>
          <div v-if="item.test && item.test.length > 0">
            <div v-for="(test, index) in item.test" :key="'test' + index" class="d-flex align-center">
              {{formatDateSlash(test.date_test)}}: {{test.score}} điểm
              <div v-if="test.comparePointAveragePoint" class="ml-2 d-flex align-center" style="font-size: 12px">
                <div v-if="test.compareAveragePoint === 'decrease'" class="d-flex align-center mr-1">
                  <img src="../assets/arrow-down.svg" height="12" width="12" alt="">
                </div>
                <div v-else-if="test.compareAveragePoint === 'increase'" class="d-flex align-center mr-1">
                  <img src="../assets/arrow-up.svg" height="12" width="12" alt="">
                </div>
                <div :style="`color: ${test.compareAveragePoint === 'decrease' ? 'red' : 'green'}`">
                  {{Math.round(+test.comparePointAveragePoint)}}
                </div>
              </div>
              <img v-if="test.link" @click="handleOpenLink(test.link)" src="../../student_detail_bt/assets/detail-highlight-icon.svg" style="height: 14px; width: 14px; cursor: pointer; margin-left: 8px" alt="">
            </div>
          </div>
          <div v-else>
            <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </td>
        <td>
          <div v-if="item.cancel_lesson && item.cancel_lesson.data.length > 0" class="d-flex align-center">
            {{item.cancel_lesson.lessons}} buổi
            <v-tooltip bottom v-if="_.get(item, 'cancel_lesson.data', []).length > 0">
              <template v-slot:activator="{ on, attrs}">
                <div>
                  <img v-if="item.cancel_lesson.isRevertCancel" class="ml-3" v-on="on" v-bind="attrs" src="../assets/danger-icon.svg" alt="">
                  <v-icon v-else v-on="on" v-bind="attrs" class="ml-3">
                    mdi-information-outline
                  </v-icon>
                </div>
              </template>
              <div>
                <div v-for="(lesson, index) in item.cancel_lesson.data" :key="'cancel_lesson' + index">
                  {{index +1}}. {{lesson.text}}
                  <img v-if="lesson.isRevertCancel" src="../assets/danger-icon.svg" alt="" class="ml-1">
                </div>
              </div>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <img @click="handleShowDetail(item, item.cancel_lesson.logIds)" v-on="on" v-bind="attrs" src="../../student_detail_bt/assets/detail-highlight-icon.svg" alt="" class="ml-2" style="cursor: pointer">
              </template>
              <div>Xem chi tiết</div>
            </v-tooltip>
          </div>
          <div v-else>
            <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </td>
        <td>
          <div v-if="item.change_teacher && item.change_teacher.data.length > 0" class="d-flex align-center">
            {{item.change_teacher.data.length}} buổi
            <v-tooltip bottom class="ml-1" v-if="_.get(item, 'change_teacher.data', []).length > 0">
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <img v-if="item.change_teacher.isDelete" v-on="on" v-bind="attrs" class="ml-3" src="../assets/danger-icon.svg" alt="">
                  <v-icon v-else v-on="on" v-bind="attrs" style="font-size: 20px" class="ml-3">
                    mdi-information-outline
                  </v-icon>
                </div>
              </template>
              <div>
                <div v-for="(lesson, index) in item.change_teacher.data" :key="'change_teacher' + index">
                  {{index +1}}. {{lesson.text}}
                  <img v-if="lesson.isDelete" src="../assets/danger-icon.svg" alt="" class="ml-1">
                </div>
              </div>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <img @click="handleShowDetail(item, item.change_teacher.logIds)" v-bind="attrs" v-on="on" src="../../student_detail_bt/assets/detail-highlight-icon.svg" class="ml-3" style="height: 14px; width: 14px; cursor: pointer" alt="">
              </template>
              <div>Mở xem chi tiết</div>
            </v-tooltip>
          </div>
          <div v-else>
            <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </td>
        <td>
          <div v-if="item.date_next_test">
            {{formatDateSlash(item.date_next_test)}}
          </div>
          <div v-else>
            <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'SpecialCareDetailTable',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleOpenLink(link) {
      window.open(link, '_blank');
    },
    handleShowDetail() {
      this.$emit('show-detail');
    },
  },
};
</script>

<style lang="scss">
.special-detail-table {
  table {
    width: 100%;
    thead {
      th {
        background-color: rgba(248, 146, 52, 0.3);
        color: black !important;
        font-size: 12px !important;
      }
    }
    tbody {
      tr {
        td {
          background-color: #0000000D;
          padding: 16px !important;
        }
      }
    }
  }
}
</style>
